import { Component, OnInit } from "@angular/core";
import { ErrorMessage } from "./error-message";
import { MessageService } from "../message.service";
import { LocalStorageService } from "../../../../local-storage/local-storage.service";
import { ButtonAction } from "../../../../services/base-http.service";

@Component({
  standalone: false,
  selector: 'app-error-modal',
  templateUrl: './error-modal.component.html'
})
export class ErrorModalComponent implements OnInit {
  message: ErrorMessage;
  appColor: string;
  processing = false;

  constructor(private messageService: MessageService,
              private localStorageService: LocalStorageService) {
  }

  ngOnInit(): void {
    this.appColor = this.localStorageService.get("app_color");
    this.message = this.messageService.errorMessage;
  }

  hideMessage(): void {
    this.messageService.hideErrorMessage();
  }

  buttonClicked() {
    this.anyButtonClicked(this.message.errorObject.buttonAction);
  }

  secondaryButtonClicked() {
    this.anyButtonClicked(this.message.errorObject.secondaryButtonAction);
  }

  private anyButtonClicked(action: ButtonAction) {
    this.processing = true;
    if (action === "CLOSE") {
      this.hideMessage();
    } else {
      this.messageService.actionButtonClicked(action);
    }
    setTimeout(() => {
      this.processing = false;
    }, 3000);
  }
}
